import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Button } from 'reactstrap';
import Navigation from '../../components/Navigation/Navigation';
import AuthorizedUser from '../../components/AuthorizedUser/AuthorizedUser';
import { saveAuthUser, removeAuthUser, setAuthUserNumber } from '../../actions/authUserAction';
import { setApplicationAuthUsers } from '../../actions/applicationAction';
import { AuthUserValidator } from '../../utils/Validators';
import {isMobile} from 'react-device-detect';
import { scroller, animateScroll } from 'react-scroll'
import withBackgroundImage from '../../HOC/withBackgroundImage';
import debounce from 'debounce';

import './AddAuthorizedUsers.scss';

class AddAuthorizedUsers extends Component {
  //Bug 452806: Fixed issue where the app autoscrolled to a specific input field on page load. Now it will scroll to the top.
  componentDidMount() {
    animateScroll.scrollToTop({
      duration: 500,
      smooth: true,
    });
  }

  constructor(props) {
    super(props);
    this.validator = AuthUserValidator();

    this.state = {
      authUsers: this.props.authUsers || [],
      validations: [...this.props.authUsers.map(authUser => { return(this.validator.valid());})],
      autoFocusIndex: 0,
      fieldsEdited: (this.props.authUsers.filter(authUser => authUser.firstName).length > 0)
    }

    this.onClickForward = this.onClickForward.bind(this);
    this.onClickBackward = this.onClickBackward.bind(this);
    this.saveAuthUser = this.saveAuthUser.bind(this);
    this.removeAuthUser = this.removeAuthUser.bind(this);
    this.addAuthUser = this.addAuthUser.bind(this);
    this.updateAuthUser = this.updateAuthUser.bind(this);
    this.validateField = this.validateField.bind(this);
    this.resetFieldValidation = this.resetFieldValidation.bind(this);
    this.resetAddressFieldValidation = this.resetAddressFieldValidation.bind(this);
  }
  onClickForward(event) {
    event.preventDefault();
    let validations = this.state.validations;
    let authUsersToRemove = [];
    let numAuthUsers = 0;
    this.state.authUsers.forEach((authUser, index) => {
      validations = [...validations.slice(0, index), 
        this.validator.validate(authUser),
        ...validations.slice(index + 1)];
        if(!authUser.manualEntry) {
          validations = [...validations.slice(0, index), 
            {...validations[index], ...{
              homeAddress: {
                isInvalid: true,
                message: "Oops, home address is a required field"
              }        
            }},
            ...validations.slice(index + 1)];
          validations[index].isValid = false
        }
        numAuthUsers++;
    });

    // Save the validation state
    this.setState({
      validations: validations
    }, () => {
      // Scroll up the first error
      let authUserIndex = validations.findIndex(validation => !validation.isValid);
      if(authUserIndex >= 0) {
        scroller.scrollTo(`auth-user-${authUserIndex}-invalid`, {
          duration: 1000,
          smooth: "easeOutQuint"
        });
      }
    });
  
    // If there are no validation errors, save each auth users
    if(validations.filter(validation => !validation.isValid).length === 0) {
      this.state.authUsers.forEach((authUser, i) => {
        this.props.saveAuthUser(authUser, i);
      });

      // Remove empty auth users
      authUsersToRemove.map(index => this.props.removeAuthUser(index));
      this.props.setApplicationAuthUsers(numAuthUsers);
      this.props.history.replace('/Bpi');
    }  
  }
  onClickBackward() {
    this.props.history.replace('/AuthorizedUsers');
  }
  updateAuthUser(authUser, index) {
    this.setState({
      authUsers: [...this.state.authUsers.slice(0, index), authUser, ...this.state.authUsers.slice(index + 1, this.state.authUsers.length)],
      fieldsEdited: true
    }); 
    this.saveAuthUser(authUser, index);
  }
  saveAuthUser = debounce((authUser, index) => {      
    this.props.saveAuthUser(authUser, index);
  }, 1000);
  removeAuthUser(index) {
    this.setState({
      authUsers:[...this.state.authUsers.slice(0, index), ...this.state.authUsers.slice(index + 1, this.state.authUsers.length)],
      validations: [...this.state.validations.slice(0, index), ...this.state.validations.slice(index + 1, this.state.validations.length)]
    }, () => {
      this.props.setApplicationAuthUsers(this.state.authUsers.length);
    });

    this.props.removeAuthUser(index);
  }
  resetFieldValidation(event, index) {
    this.setState({
      validations:[...this.state.validations.slice(0, index), 
        {...this.state.validations[index], [event.target.name]: this.validator.resetFieldValidation(event.target.name)},
        ...this.state.validations.slice(index + 1)]
    });
  }
  resetAddressFieldValidation(index) {    
    this.setState({
      validations:[...this.state.validations.slice(0, index), 
        {...this.state.validations[index], 
          address1: this.validator.resetFieldValidation("address1"),
          address2: this.validator.resetFieldValidation("address2"),
          city: this.validator.resetFieldValidation("city"),
          province: this.validator.resetFieldValidation("province"),
          postalCode: this.validator.resetFieldValidation("postalCode"),
          homeAddress: {
            isInvalid: false,
            message: ""
          }
        },
        ...this.state.validations.slice(index + 1)]
      });
  }
  addAuthUser() {
    let authUsers = [];
    let num = this.state.authUsers.length + 1

    // Find the larest array index, and add one to make it unqiue
    let id = Math.max(...this.state.authUsers.map(authUser => authUser.id), 0) + 1;
    // PBI 441340 VOA: Set 'Email' as a required field and add it to the Authorized User form
    // PBI 441341 VOA: Replace the drop-down for the Primary and Authorized User Phone fields with two separate input fields for Mobile and Home phone numbers
    authUsers = [...this.state.authUsers, ...(new Array(num - this.state.authUsers.length).fill(null).map((val, i) => ({id: i + id, firstName: "", lastName: "", birthdate: "", address1: "", address2: "", city: "", province: "BC", postalCode: "", mobilePhone: "", homePhone:"", email: "", status: "Employed", industry: "", occupationName: "", noc: "" })))];

    this.setState({
      authUsers:authUsers,
      validations: [...this.state.validations, this.validator.valid()],
      autoFocusIndex: this.props.authUsers.length
    });
    this.props.setAuthUserNumber(this.props.authUsers.length + 1);
    this.props.setApplicationAuthUsers(num);
  }
  validateField(event, index) {  
    this.setState({
      validations:[...this.state.validations.slice(0, index), 
        {...this.state.validations[index], [event.target.name]: this.validator.validateField(event.target.name, event.target.value)},
        ...this.state.validations.slice(index + 1)]
    });
  }

  render() {
    let addAuthUser;
    if(this.props.authUsers.length < 4) {
      addAuthUser = <Button color="link" onClick={this.addAuthUser}>Add another Authorized User</Button>
    }
    return (
      <div className="add-auth-users">
        <h1>Who would you like to add to your account?</h1>
        <Form onSubmit={this.onClickForward}>
          {this.state.authUsers.map((authUser, i) => {        
            return (<AuthorizedUser 
                        key={authUser.id} 
                        index={i} 
                        authUser={authUser} 
                        validateField={this.validateField} 
                        resetFieldValidation={this.resetFieldValidation} 
                        validation={this.state.validations[i]} 
                        updateAuthUser={this.updateAuthUser} 
                        saveAuthUser={this.saveAuthUser} 
                        removeAuthUser={this.removeAuthUser} 
                        resetAddressFieldValidation={this.resetAddressFieldValidation} 
                        address={this.props.personalInfo.address}
                        autoFocus={(i === this.state.autoFocusIndex && !isMobile)} />);
          })}   
          {addAuthUser}
          <Navigation onClickForward={this.onClickForward} onClickBackward={this.onClickBackward} />
        </Form>
      </div>);
  }
}
const mapStateToProps = state => ({
  authUsers: state.authUsers,
  personalInfo: state.personalInfo,
});

const mapDispatchToProps = dispatch => ({
  saveAuthUser: (authUser, index) => dispatch(saveAuthUser(authUser, index)),
  removeAuthUser: (index) => dispatch(removeAuthUser(index)),
  setAuthUserNumber: (num) => dispatch(setAuthUserNumber(num)),
  setApplicationAuthUsers: (numAuthUsers) => dispatch(setApplicationAuthUsers(numAuthUsers)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withBackgroundImage("auth-users")(AddAuthorizedUsers));


// WEBPACK FOOTER //
// ./src/containers/AddAuthorizedUsers/AddAuthorizedUsers.js